import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => (
  <motion.a
    data-testid="whatsapp-float-button"
    href="https://wa.me/919730527427?text=Hi%20Madhura%2C%20I%20have%20a%20question%20about%20investing."
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.92 }}
    className="fixed bottom-6 right-6 z-50 block"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
    <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,0.7)]">
      <MessageCircle size={26} fill="currentColor" />
    </span>
  </motion.a>
);
